import { Dialog } from '@headlessui/react';
import React from 'react';

function ConfirmationModal({ show, title, onConfirm, onCancel }) {
  if (!show) {
    return null;
  }

  return (
    <Dialog open={show} onClose={onCancel} className="relative z-[9999]">
      <div className="fixed inset-0 flex items-center justify-center ">
        <div className="bg-black opacity-50 absolute inset-0"></div>
        <div className="bg-white p-6 rounded shadow-lg z-10">
          <h2 className="mb-4 text-lg">Confirm Deletion</h2>
          <p>{title ? `Are you sure you want to delete "${title}"?` : `Are you sure you want to delete this item?`}</p>
          <div className="mt-4 flex justify-end">
            <button className="mr-2 px-4 py-2 bg-gray-200 rounded cursor-pointer" onClick={onCancel}>Cancel</button>
            <button className="px-4 py-2 bg-red-500 text-white rounded cursor-pointer" onClick={onConfirm}>Delete</button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default ConfirmationModal;
